/*
 * Author: Roger
 * File Created: Monday, 24-08-26 01:55 pm
 * Last Modified: Thursday, 25-03-06 11:11 am, by Ben Zhao
 */

import { formatNumber } from '@web/utils';

export const formatAssetNumber = (
  num: (number | string) | undefined,
  n = 2,
) => {
  if (!num) return '0.00';
  const numStr = num.toString();
  const intPart = numStr.split('.')[0];
  const decimals = numStr.split('.')[1];
  const realN = decimals && decimals.length > n ? decimals.length : n;

  if (realN > 2) {
    if (Number(intPart) === 0) {
      return numStr;
    }

    return `${formatNumber(intPart, 0)}.${decimals}`;
  }

  return formatNumber(numStr, realN);
};

export const formatToPercent = (num: (number | string) | undefined, n = 2) => {
  if (!num) return '';
  const numStr = num.toString();
  const decimals = numStr.split('.')[1];
  const decLen = decimals?.length || 3;

  return `${formatNumber(Number(num) * 100, Math.min(n, decLen - 2))}%`;
};
